import { render, staticRenderFns } from "./AccountTeaser.vue?vue&type=template&id=448fa316&scoped=true"
import script from "./AccountTeaser.vue?vue&type=script&lang=js"
export * from "./AccountTeaser.vue?vue&type=script&lang=js"
import style0 from "./AccountTeaser.vue?vue&type=style&index=0&id=448fa316&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448fa316",
  null
  
)

export default component.exports